import Firebase from 'firebase';
import appConfig from '../../appConfig';

const { firebase, firebaseKey } = appConfig;

// Initialize Firebase
const config = {
  apiKey: firebaseKey,
  authDomain: `${firebase}.firebaseapp.com`,
  databaseURL: `https://${firebase}.firebaseio.com`,
  storageBucket: `${firebase}.appspot.com`
};
Firebase.initializeApp(config);

export const authRef = Firebase.auth();
export const ref = Firebase.database().ref();
export const TIMESTAMP = Firebase.database.ServerValue.TIMESTAMP;
export default ref;



// WEBPACK FOOTER //
// ./src/services/firebaseRef.js